jQuery('body').on("click",'button.product-form__submit', function (event, cart) {
  if($(this).text().includes('Sold out') == false){
    $('.cart-modal').addClass('open')
  }
});



function handleModalOpen() {
  $('.cart-modal').addClass('open')
}

function handleModalClose() {
  $('.cart-modal').removeClass('open')
}




setTimeout(function () {

  $('div.tmenu-watermark').addClass('test');


}, 1000);

//ADD TO CART QUANTITY 

jQuery('.quantity__button').click(function () {

  productQuantity();

});

function productQuantity() {
  setTimeout(function () {

    var quantityValue = jQuery('.quantity__input').val();
    jQuery('button.product-form__submit').attr('data-cart-quantity', quantityValue);

  }, 500);
}





$("#Search-In-Modal").keyup(function () {
  //  console.log('pressed')
  if ($(this).val().length > 0) {
    $('.search-modal .field__label').hide();
  }
  else {
    $('.search-modal .field__label').show();
  }
});

if (jQuery('body').hasClass('search')) {

  $("#Search-In-Template").keyup(function () {
    if ($(this).val().length > 0) {
      $('.template-search__search .field__label').hide();
    }
    else {
      $('.template-search__search .field__label').show();
    }
  });
  if ($('#Search-In-Template').val().length > 0) {

    $('.template-search__search .field__label').hide();

  }
  else {
    $('.template-search__search .field__label').show();

    $("#Search-In-Template").keyup(function () {
      if ($(this).val().length > 0) {
        $('.template-search__search .field__label').hide();
      }
      else {
        $('.template-search__search .field__label').show();
      }
    });
  }
}

//CLOSE PREDICTIVE SEARCH ON MOBILE

$('.predictive-close').click(function () {
  $('predictive-search').attr('open', 'false');
});


if ($('cart-items').hasClass('is-empty')) {
  $('cart-items').parent('.shopify-section').addClass('empty');
  $('.cart__footer-wrapper').addClass('empty');
}

function checkMockFilters() {
  var originFilterContainer = document.getElementById('Occasion');
  if (originFilterContainer) {
    var originMockFilters = originFilterContainer.querySelectorAll('.mock-filters input');
    var originFilters = originFilterContainer.querySelectorAll('.filters input');
    var activeOriginFilters = [];

    for (i = 0; i < originMockFilters.length; ++i) {
      if (originMockFilters[i].checked == true) {
        activeOriginFilters.push(originMockFilters[i].value);
      }
    }

    for (i = 0; i < originFilters.length; ++i) { // Uncheck all filters
      originFilters[i].checked = false;
    }

    for (i = 0; i < originFilters.length; ++i) { // Loop through mock filters, check all filters that contain the mock filter values
      for (ii = 0; ii < activeOriginFilters.length; ++ii) {
        if (originFilters[i].value.includes(activeOriginFilters[ii])) {
          originFilters[i].checked = true;
        }
      }
    }
  }
}


//HIDE LABELS ON INPUTS
$('input:not(#mce-EMAIL)').each(function () {

  $(this).keyup(function () {
    if ($(this).val().length > 0) {
      $(this).parent().children('label').hide();
    }
    else {
      $(this).parent().children('label').show();
    }
  })

});

//HIDE LABELS ON TEXTAREA
$('textarea').each(function () {

  $(this).keyup(function () {
    if ($(this).val().length > 0) {
      $(this).parent().children('label').hide();
    }
    else {
      $(this).parent().children('label').show();
    }
  })

});


//CHANGE HEADER LOGOS ON BODY

$('details').click(function () {
  setTimeout(function () {

    if ($('details').hasClass('menu-opening')) {
      $('.header__icons').addClass('text')
    } else {
      $('.header__icons').removeClass('text')
    }

  }, 200);


})



//PRICE FILTERS
function priceFilterCheck() {
  if (window.location.href.indexOf("lte=75") > -1) {
    setTimeout(function () {
      $('.under-seventyfive input').prop("checked", true);
    }, 1000);
  }
  if (window.location.href.indexOf("lte=100") > -1) {
    setTimeout(function () {
      $('.under-hundred input').prop("checked", true);
    }, 1000);
  }
  if (window.location.href.indexOf("lte=150") > -1) {
    setTimeout(function () {
      $('.under-onefifty input').prop("checked", true);
    }, 1000);
  }
  if (window.location.href.indexOf("lte=200") > -1) {
    setTimeout(function () {
      $('.under-twohundred input').prop("checked", true);
    }, 1000);
  }
  if (window.location.href.indexOf("gte=200") > -1) {
    setTimeout(function () {
      $('.over-twohundred input').prop("checked", true);
    }, 1000);
  }

  $('.main-collection-filters details').each(function () {

    foundIt = false;

    $(this).find('.facets__list').find('.list-menu__item').each(function () {
      if (foundIt === false) {
        if ($(this).find('input').is(':checked')) {
          foundIt = true;
          $(this).addClass('has-checked');
          $(this).parent().addClass('has-checked');
        } else {
          $(this).removeClass('has-checked');
          $(this).parent().removeClass('has-checked');
        }

      } else {
        //DO NOTHING
      }

    })
  })

}

priceFilterCheck();

var foundIt

$('.main-collection-filters').click(function () {

  setTimeout(function () {
    priceFilterCheck();

    //HIDE FEATURED ON COLLECTION PAGE

    if (window.location.href.indexOf("filter") > -1) {
      $('.collection-featured-product').hide();
    } else {
      $('.collection-featured-product').show();
    }

  }, 1000);

})

$(document.body).on('change', '#SortBy', function () {
  setTimeout(function () {
    priceFilterCheck();
  }, 2000);
});

$(document).ready(function () {
  if (window.location.href.indexOf("filter") > -1) {
    $('.collection-featured-product').hide();
  } else {
    $('.collection-featured-product').show();
  }
})


//REMOVE BOXES AND BROCHURE FROM BASKET --OLD STUFF

//function checkBoxes() {
//  
//  $('.cart-item').each(function(){
//    
//    //ADD NEW BOXES DEPENDING ON UPDATED QUANTITIES/PRODUCTS
//    var boxSize = $(this).find('.boxsize').html();
//    var quanity = $(this).find('.quantity__input').val();
//    console.log(boxSize + quanity)
//    
//    if (boxSize.indexOf("SMALL") >= 0) {
//      CartJS.addItem(43090779504873, quanity); //SMALL
//    }
//    if (boxSize.indexOf("MEDIUM") >= 0) {
//      CartJS.addItem(43090861064425, quanity); //MEDIUM
//    }
//    if (boxSize.indexOf("LARGE") >= 0) {
//      CartJS.addItem(43090861981929, quanity); //LARGE
//    }
//  
//  })
//  
//  //ADD BROCHURE
//  CartJS.addItem(43093926936809, 1); //BROCHURE
//  
//}
//
//var slept = false;
//
//$("h2").click(function(event) {
//  if(!slept) {
//    event.preventDefault();
//    checkBoxes();
//
//    var $element = $(this);
//
//    setTimeout(function() {
//      slept = true;
//      $element.click(); 
//    }, 4000);
//  } else {
//      slept = false; 
//  }
//});
//
////REMOVE BOXES FROM CART ON ALL PAGES
//$(document).ready(function(){
//  
////    CartJS.removeItemById(43090779504873);
////    CartJS.removeItemById(43090861064425);
////    CartJS.removeItemById(43090861981929);
////    CartJS.removeItemById(43093926936809); //BROCHURE
//  
//  //HIDE BOX AND BROCHURE ITEMS FROM CART PAGE
//  
//  $('.cart-item').each(function(){
//    
//    var itemTitle = $(this).find('.cart-item__name').html();
//    
//    if (itemTitle.indexOf("box") >= 0) {
//      $(this).hide();
//    }
//    if (itemTitle.indexOf("Brochure") >= 0) {
//      $(this).hide();
//    }
//
//  });
//  
//});

//REMOVE BOXES AND BROCHURE FROM BASKET --OLD STUFF




//REMOVE BOXES AND BROCHURE FROM BASKET --NEW STUFF -- CART PAGE 
//
//var slept = false;
//
//$("#checkout").click(function(event) {
//  if(!slept) {
//    event.preventDefault();
//    var $element = $(this);
//    
//    var smallBoxQuantity = 0;
//    var mediumBoxQuantity = 0;
//    var largeBoxQuantity = 0;
//
//    $('.cart-item').each(function(){
//
//      //ADD NEW BOXES DEPENDING ON UPDATED QUANTITIES/PRODUCTS
//      var boxSize = $(this).find('.boxsize').html();
//      var quanity = $(this).find('.quantity__input').val();
//      console.log(boxSize + quanity)
//
//      if (boxSize.indexOf("SMALL") >= 0) {
//        smallBoxQuantity = parseInt(smallBoxQuantity) + parseInt(quanity);
//      }
//      if (boxSize.indexOf("MEDIUM") >= 0) {
//        mediumBoxQuantity = parseInt(mediumBoxQuantity) + parseInt(quanity);    
//      }
//      if (boxSize.indexOf("LARGE") >= 0) {
//        largeBoxQuantity = parseInt(largeBoxQuantity) + parseInt(quanity);  
//      }
//
//    }).promise().done( function(){ 
//      console.log('small ' + smallBoxQuantity)
//      console.log('medium ' + mediumBoxQuantity)
//      console.log('large ' + largeBoxQuantity)
//
//      CartJS.updateItemQuantitiesById({43090779504873: smallBoxQuantity, 43090861064425: mediumBoxQuantity, 43090861981929: largeBoxQuantity, 43093926936809: 1});
//      
//      setTimeout(function() {
//        slept = true;
//        $element.click(); 
//      }, 4000);
//      
//    });
//    
//  } else {
//      slept = false; 
//  }
// 
//});



//UPDATE BOXES IN MODAL PULLOUT

//jQuery(document).on("cart.requestComplete", function (event, cart) {
//  
//});


//ADD BOX
//
//
//$('.cart-box-notes .small').html(localStorage.getItem('cartBoxNotesSmall'));
//
//console.log(localStorage.getItem('cartBoxNotesSmall'));
//
//$('.product-form__submit').click(function(){
//  var boxSize = $('.variant-container .box-size').html()
//  if (boxSize.indexOf("SMALL") >= 0) {
//    var currentStorage = localStorage.getItem('cartBoxNotesSmall');
//    var newStorage = localStorage.getItem('cartBoxNotesSmall') + parseInt(1);
//    localStorage.setItem('cartBoxNotesSmall', 1);
//    $('.cart-box-notes .small').html(localStorage.getItem('cartBoxNotesSmall'));
//    console.log(localStorage.getItem('cartBoxNotesSmall'));
//    
//  }
//  
//  
//})


//$('.product-form__submit').click(function(){
//  var productTitle = $('.product__title').html();
////  var boxSize = $('.variant-container .box-size').html();
////  var prodQuantity = 1;
//  var productInfo = $('.product__title').html() + $('.variant-container .box-size').html() + parseInt(1);
//  
//  localStorage.setItem('product', productInfo);
//  
//  $('.cart-box-notes').append(localStorage.getItem('product', productInfo));
//  var initData = ['products'];
//
//  localStorage.setItem('keywords', JSON.stringify(initData));
//
//  $(".product-form__submit").click(function(){
//    var productTitle = $('.product__title').html();
//    var oldValue = JSON.parse(localStorage.getItem('keywords'));
//
//    oldValue.push(productTitle);
//
//    localStorage.setItem('keywords', JSON.stringify(oldValue));
//    
//    console.log(JSON.parse(localStorage.getItem('keywords')));
//  })

//  $("#getData").click(function(){
//      
//  })



//})


$(document).ready(function () {
  //  var brochureadded = "no";

  //CART MODAL
  $('#cart__checkout_btn').click(function () {


    var cartnoteval = $('#Cart-note').val();

    CartJS.setNote(cartnoteval);

    if ($(this).hasClass('bold_clone') && window.upsellPopped == null) {
      window.upsellPopped = true
      setTimeout(function () {
        $('.checkout-button-hidden').trigger('click')
      }, 1000);
    }
    else if ($(this).hasClass('bold_clone')) {
      window.location.href = '/checkout'
    }
    else {
      setTimeout(function () {
        window.location.href = '/checkout'
      }, 1000);
    }


  })
  //
  //    //CHECK FOR BROCHURE & ADD IF NOT THERE
  //
  //      $('.table-items').each(function(){
  //
  //        var prodtitle = $(this).find('.title').find('p').html();
  //
  //        if (brochureadded.indexOf("no") >= 0) {
  //
  //          if (prodtitle.indexOf("Brochure") >= 0) {
  //            brochureadded = "yes"
  //          } else {
  //            CartJS.addItem(43093926936809, 1);//BROCHURE
  //            brochureadded = "yes"
  //          }
  //        } 
  //
  //      }).promise().done( function(){ 
  //        
  //        setTimeout(function(){
  //          window.location.href = "/checkout"; 
  //        }, 1000);
  //      
  //    });


  //CART PAGE
  $('#checkout').click(function () {

    var cartnoteval = $('.gift-card-container #Cart-note').val();

    CartJS.setNote(cartnoteval);

    setTimeout(function () {
      window.location.href = "/checkout";
    }, 1000);

    //CHECK FOR BROCHURE & ADD IF NOT THERE

    //      $('.cart-item').each(function(){
    //
    //        var prodtitle = $(this).find('.cart-item__name').html();
    //
    //        if (brochureadded.indexOf("no") >= 0) {
    //
    //          if (prodtitle.indexOf("Brochure") >= 0) {
    //            brochureadded = "yes"
    //          } else {
    //            CartJS.addItem(43093926936809, 1);//BROCHURE
    //            brochureadded = "yes"
    //          }
    //
    //        } 
    //
    //      });

  })

});
